export const EQUIPMENT = '[EQUIPMENT]'
export const ADD_TO_EQUIPMENT = `${EQUIPMENT} Equip Items`
export const REMOVE_FROM_EQUIPMENT = `${EQUIPMENT} Unequip Items`

export const addToEquipment = (items, unitID) => ({
    type: ADD_TO_EQUIPMENT,
    payload: {
        items,
        unitID,
    },
    meta: {
        persisted: 'equipment',
        checkEquipment: 'add',
    },
})

export const removeFromEquipment = items => ({
    type: REMOVE_FROM_EQUIPMENT,
    payload: {
        items,
    },
    meta: {
        persisted: 'equipment',
        checkEquipment: 'remove',
    },
})
